module.exports = __webpack_public_path__ + "img/in-charge.72aba30e.svg";